module.exports = __webpack_public_path__ + "static/img/22.fe4d6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/22.png
// module id = qAQO
// module chunks = 0